import { AppMode } from '@sportybot-web/context/app-mode/context';

export const APP_MODE_LOGO_SRC: Record<AppMode, string> = {
  [AppMode.MILB]: '/images/milb-logo.svg',
  [AppMode.MLB]: '/images/mlb-logo.svg',
};

export const APP_MODE_OPTIONS: AppMode[] = [AppMode.MLB, AppMode.MILB];
